import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';

import { useTradeAllowanceField } from './useTradeAllowanceField';

const TradeInAllowance = () => {
    const { label, errorBadgeEntity, onLabelActivate, onLabelKeyDown, inputProps } = useTradeAllowanceField();

    return (
        <>
            <label
                data-testid="trade-allowance-input-label"
                className="base-deal-activity-control-custom-label"
                onClick={onLabelActivate}
                onKeyDown={onLabelKeyDown}
                tabIndex={0}
                role="button"
            >
                <ActionWithErrorBadge entityName={errorBadgeEntity}>{label}</ActionWithErrorBadge>
                <ChevronRightIcon fontSize={10} />
            </label>
            <NumericInput {...inputProps} displayLabel={false} />
        </>
    );
};

export default TradeInAllowance;
